import { useTranslation } from 'react-i18next';

import ObjectiveHelpTooltip from './ObjectiveHelpTooltip';

/**
 * What choosing a cycle means, beside the picker that does it: a cycle keeps the objectives whose
 * dates overlap it, attached to it or not. Two cycles that overlap therefore list the same
 * objectives, and without this sentence the picker looks as though it changes nothing.
 */
export default function ObjectivesCycleHelp() {
    const { t } = useTranslation();

    return (
        <ObjectiveHelpTooltip
            label={t('objectives.period.help.label')}
            dataTestId={'objectives-period-help'}
        >
            {t('objectives.period.help.body')}
        </ObjectiveHelpTooltip>
    );
}
